/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ClientSDK } from "../lib/sdks.js";
import { ApiKeys } from "./apikeys.js";
import { Apps } from "./apps.js";
import { Deploy } from "./deploy.js";
import { Deployments } from "./deployments.js";
import { Domains } from "./domains.js";
import { Environments } from "./environments.js";
import { Gateway } from "./gateway.js";
import { Github } from "./github.js";
import { Liveness } from "./liveness.js";
import { Projects } from "./projects.js";

export class Teral extends ClientSDK {
  private _apiKeys?: ApiKeys;
  get apiKeys(): ApiKeys {
    return (this._apiKeys ??= new ApiKeys(this._options));
  }

  private _apps?: Apps;
  get apps(): Apps {
    return (this._apps ??= new Apps(this._options));
  }

  private _deploy?: Deploy;
  get deploy(): Deploy {
    return (this._deploy ??= new Deploy(this._options));
  }

  private _deployments?: Deployments;
  get deployments(): Deployments {
    return (this._deployments ??= new Deployments(this._options));
  }

  private _domains?: Domains;
  get domains(): Domains {
    return (this._domains ??= new Domains(this._options));
  }

  private _environments?: Environments;
  get environments(): Environments {
    return (this._environments ??= new Environments(this._options));
  }

  private _gateway?: Gateway;
  get gateway(): Gateway {
    return (this._gateway ??= new Gateway(this._options));
  }

  private _github?: Github;
  get github(): Github {
    return (this._github ??= new Github(this._options));
  }

  private _liveness?: Liveness;
  get liveness(): Liveness {
    return (this._liveness ??= new Liveness(this._options));
  }

  private _projects?: Projects;
  get projects(): Projects {
    return (this._projects ??= new Projects(this._options));
  }
}
